import { useContext } from 'react'

import { CalendarContext } from '../../Calendar.context'

export function useCalendarContext() {
  return useContext(CalendarContext)
}
